"use strict";

require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var ExpressionUtils = /*#__PURE__*/_createClass(function ExpressionUtils() {
  _classCallCheck(this, ExpressionUtils);
});
exports.default = ExpressionUtils;
ExpressionUtils.isLiteral = function (s) {
  return /^'.*'$/.test(s);
};
ExpressionUtils.CUSTOM_OPS = {
  neq: function neq(arg, arg2) {
    return !_lodash.default.eq(arg, arg2);
  },
  noCorrectValues: function noCorrectValues(arg, arg2, arg3) {
    return arg2 !== arg && arg3 !== arg;
  }
};
ExpressionUtils.resolveArg = function (arg, data) {
  if (_lodash.default.isString(arg)) {
    if (ExpressionUtils.isLiteral(arg)) {
      // String literals - strip off enclosing quotes
      return arg.replace(/(^')|('$)/g, '');
    }
    // Otherwise, interpret the string as a "data path", and return the value at the specified path
    else return _lodash.default.get(data, arg);
  }
  // Otherwise, return unprocessed (e.g. Arrays for "includes")
  return arg;
};
ExpressionUtils.eval = function (exp, data) {
  var fn = function fn() {};
  if (typeof _lodash.default[exp.op] === 'function') {
    fn = _lodash.default[exp.op];
  } else if (typeof ExpressionUtils.CUSTOM_OPS[exp.op] === 'function') {
    fn = ExpressionUtils.CUSTOM_OPS[exp.op];
  } else {
    // throw an exception...
  }
  return fn.apply(void 0, _toConsumableArray(exp.args.map(function (arg) {
    return ExpressionUtils.resolveArg(arg, data);
  })));
};
ExpressionUtils.isHidden = function (config, data) {
  if (config.isHidden) {
    return ExpressionUtils.eval(config.isHidden, data);
  }
  return false;
};